export default {"src":"/_next/static/media/pod-logo.91f9349a.svg","height":40,"width":67};